module.exports = __webpack_public_path__ + "img/ava-post1.a64b025e.jpg";